import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapLink, BootstrapNav } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { AppTheme } from '../_contracts';
import { LineHeader } from '../_components/ui';
import { versions } from './versions';
import { LineHeaderContent } from '../TeaserBox/_partials';
// import { LineHeaderContent } from './_partials'
let QuotationsModuleUi = class QuotationsModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.AppTheme = AppTheme;
        this.activeTab = '';
        this.headerImage = null;
        this.headerLink = null;
        this.tabs = [];
    }
    get component() {
        const component = versions.find(v => v.moduleVersion === this.module.version);
        if (typeof component !== 'function') {
            throw new Error(`QuotationsModuleUi.[get]component: Failed to resolve the applicable Quotations variant component for the given version! Current [module.version]: [${this.module.version}].`);
        }
        return component;
    }
    get lineHeaderTitleTag() {
        if (this.module.content.header) {
            return this.module.content.header.isH1 ? 'h1' : 'h2';
        }
        return 'h2';
    }
    fetchRelatedSync() {
        try {
            const itemsToResolve = Array.isArray(this.module.content.tabs) ? this.module.content.tabs : [];
            itemsToResolve.map((rawTab, index) => {
                this.resolveSingleTab(rawTab, index);
            });
        }
        catch (e) {
            this.onError(e);
        }
    }
    get hasHeaderText() {
        return typeof this.module.content.header !== 'undefined' &&
            typeof this.module.content.header.text === 'string' &&
            this.module.content.header.text.length > 0;
    }
    isTabActive(label) {
        return this.activeTab === label;
    }
    get navItems() {
        return this.tabs.map(({ id, label }) => ({
            disabled: false,
            id,
            label
        }));
    }
    get shouldShowHeader() {
        const { header = {} } = this.module.content;
        // if (!this.module.content.showHeader) {
        //   return false
        // }
        const keys = ['site', 'text'];
        for (const key of keys) {
            const value = header[key];
            if (typeof value === 'string' && value.length > 0) {
                return true;
            }
        }
        return false;
    }
    resolveSingleTab(rawTab, index) {
        const { items } = rawTab;
        let quotations = [];
        try {
            quotations = items.map(item => this.relatedService.resolveSync(item));
        }
        catch (e) {
            if (this.debug)
                console.warn(e);
        }
        this.tabs[index] = {
            ...this.tabs[index],
            items: quotations
        };
    }
};
QuotationsModuleUi = __decorate([
    Component({
        name: 'QuotationsModuleUi',
        components: {
            BootstrapNav,
            BootstrapLink,
            LineHeader,
            LineHeaderContent
        },
        created() {
            if (this.module.content.tabs.length > 0) {
                this.tabs = this.module.content.tabs.map((item, index) => {
                    const prefix = this.$id('tab');
                    return {
                        id: `${prefix}-${index}`,
                        label: item.label,
                        items: []
                    };
                });
            }
            this.fetchRelatedSync();
            if (this.tabs.length > 0) {
                this.activeTab = this.tabs[0].id;
                this.onReady();
            }
            else {
                this.onError();
            }
        },
        template: `
    <section
      :class="['quotations', moduleColoredClass, debugClass, loadingClass, versionClass, getThemeByBgClass]"
      :style="{ backgroundColor: customColor }"
    >
      <!-- Header -->
      <LineHeader v-if="shouldShowHeader || tabs.length"
                  :site="module.content.header ? module.content.header.site : null"
                  :theme="getThemeByBg"
                  :isBold="module.content.header.isLink || module.content.header.bold || false"
                  :tag="lineHeaderTitleTag"
                  class="quotations__header">
        <!-- Text -->

        <LineHeaderContent v-if="theme !== AppTheme.PremiumZone && hasHeaderText"
                           :text="module.content.header.text" :headerImage="headerImage" :headerLink="headerLink" />

        <!-- Nav -->
        <template #nav>
          <BootstrapNav v-if="tabs.length > 1" :activeItem.sync="activeTab" :items="navItems" />
        </template>
      </LineHeader>

      <component v-for="tab in tabs"
                 v-if="component"
                 :is="component"
                 :key="tab.id"
                 :id="tab.id"
                 :active="isTabActive(tab.id)"
                 :items="tab.items"
                 v-bind="{ DeMarked, fallbackImage, isLazy: module.isLazyLoaded, isMobile }"
      />
    </section>
  `
    })
], QuotationsModuleUi);
export { QuotationsModuleUi };
